export default __webpack_public_path__ + "static/media/330_store04-es-web.4f6250cc.png";